import React from 'react';
import { Box, Heading } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import SocialProfile from './SocialProfile';
import About from './About';
import KeyPassionsSection from './KeyPassionsSection';
import BibleVerse from './BibleVerse';
import BioSection from './BioSection';

const MotionBox = motion(Box);

const Home = () => (
  <>
    {/* Hero Section */}
    <MotionBox
      bgGradient="linear(to-r, pastelPink, pastelBlue)"
      py={10}
      px={6}
      color="white"
      id="home"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.6 }}
      boxShadow="lg"
      borderRadius="lg"
      position="relative"
    >
      <Heading mb={6} fontSize="4xl" color="white">
        Discover Inspiration with Suzan Cook
      </Heading>
      <SocialProfile />
    </MotionBox>

    {/* About Section */}
    <MotionBox
      py={10}
      px={6}
      bg="pastelWhite"
      id="about"
      initial={{ opacity: 0, x: -100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 100 }}
      transition={{ duration: 0.8 }}
      boxShadow="md"
      borderRadius="lg"
    >
      <About />
    </MotionBox>

    {/* Key Passions Section */}
    <MotionBox
      py={10}
      px={6}
      bg="pastelGreen"
      id="passions"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      transition={{ duration: 0.8 }}
      boxShadow="md"
      borderRadius="lg"
    >
      <KeyPassionsSection />
    </MotionBox>

    {/* Bible Verse Section */}
    <MotionBox
      py={10}
      px={6}
      bg="pastelBlue"
      id="bible-verse"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.8 }}
      boxShadow="md"
      borderRadius="lg"
    >
      <BibleVerse />
    </MotionBox>

    {/* Bio Highlights Section */}
    <MotionBox
      py={10}
      px={6}
      bg="pastelYellow"
      id="bio"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.6 }}
      boxShadow="md"
      borderRadius="lg"
    >
      <BioSection />
    </MotionBox>
  </>
);

export default Home;
